/**
 * Fuß der Belegliste: lädt weitere Belege nach, sobald er ins Bild scrollt —
 * und bietet dafür zusätzlich einen Knopf an (falls der Beobachter nicht greift).
 * Bei einer Suche sagt er stattdessen, wie viele Treffer es insgesamt gibt.
 */
import { useEffect, useRef } from "react";

export default function ListenEnde({
  geladen, gesamt, hatMehr, laedtMehr, mehrLaden, serverSuche, suchGekappt, suchTreffer, angezeigt,
}: {
  geladen: number;
  gesamt: number;
  hatMehr: boolean;
  laedtMehr: boolean;
  mehrLaden: () => void;
  serverSuche: boolean;
  suchGekappt: boolean;
  suchTreffer: number;
  angezeigt: number;
}) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!hatMehr || !ref.current || typeof IntersectionObserver === "undefined") return;
    const beob = new IntersectionObserver(
      (eintraege) => { if (eintraege.some((e) => e.isIntersecting)) mehrLaden(); },
      { rootMargin: "400px 0px" },
    );
    beob.observe(ref.current);
    return () => beob.disconnect();
  }, [hatMehr, mehrLaden, geladen]);

  if (suchGekappt) {
    return (
      <div className="sf-listenende">
        Die neuesten {angezeigt} von {suchTreffer} Treffern — Suche genauer fassen.
      </div>
    );
  }
  if (serverSuche) {
    return (
      <div className="sf-listenende">
        {suchTreffer === 1 ? "1 Treffer" : `${suchTreffer} Treffer`} in allen Belegen
      </div>
    );
  }
  if (!gesamt) return null;
  return (
    <div className="sf-listenende" ref={ref}>
      {hatMehr ? (
        <button type="button" className="sf-listenende-btn" onClick={mehrLaden} disabled={laedtMehr}>
          {laedtMehr ? "Lade weitere Belege…" : `${geladen} von ${gesamt} geladen · weitere laden`}
        </button>
      ) : (
        <span>Alle {gesamt} Belege geladen</span>
      )}
    </div>
  );
}
